import { SecurityRole } from '@reg/shared/model/security-role.model';
import { UserAccount } from '@reg/shared/model';

/**
 * Model to hold the user security roles for a given event
 */
export class UserSecurityRole {
    public id: string;
    public userAccount: UserAccount = null;
    public eventId: string = '';
    public securityRoleIds: string[] = [];

    public clone(): UserSecurityRole {
        const clone: UserSecurityRole = new UserSecurityRole();
        clone.id = this.id;
        clone.eventId = this.eventId;

        if (this.userAccount) {
            clone.userAccount = this.userAccount.clone();
        }
        if (this.securityRoleIds) {
            clone.securityRoleIds = this.securityRoleIds.map((id: string) => id);
        }

        return clone;
    }

    /**
     * Serialize from a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'userSecurityRole';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.relationships = {};
        json.data.attributes.securityRoles = null;

        if (this.securityRoleIds && this.securityRoleIds.length > 0) {
            json.data.attributes.securityRoles = this.securityRoleIds;
        }

        const userAccountRelationship: any = {};
        userAccountRelationship.data = { type: 'userAccount', id: this.userAccount.id };
        json.data.relationships.userAccount = userAccountRelationship;

        return JSON.stringify(json);
    }

    /**
     * Deserialize from json
     */
    public deserialize(json: Object, included?: Object[]): UserSecurityRole {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];
        included = included || json['included'];
        const relationships: Object[] = data['relationships'] || [];

        this.id = data['id'];
        this.eventId = attrs['eventId'];
        this.securityRoleIds = attrs['securityRoles'] || [];

        const userAccountRelationship: Object = relationships['userAccount'];
        if (userAccountRelationship &&
            userAccountRelationship['data'] &&
            included) {
            const userAccountId: string = userAccountRelationship['data']['id'];
            const userAccount: Object = included.filter(
                (i: Object) => i['type'] === 'userAccount' && i['id'] === userAccountId,
            )[0];

            if (userAccount) {
                this.userAccount = (new UserAccount()).deserialize(userAccount);
            }
        }

        return this;
    }
}
